<template>
    <div>
        <div class="row">
            <div class="col-md-12">
            <div class="field field-name-body field-type-text-with-summary field-label-hidden">
                <div class="field-items">
                    <div class="field-item even">
                        <div v-if="dossier.isBaremeAjuste">
                            <div id="divBaremeAjusteImpossible" v-if="dossier.typeResident.value === 'S'">
                                <p>La demande du barème C de perception ajusté est impossible pour les contribuables résidant en Suisse hors canton de Genève.</p>
                                <p>Veuillez donc: </p>
                                <ol>
                                    <li>{{$t('Bareme.etape2.resultat.baremeAjuste.genererPDF')}}</li>
                                    <li>{{$t('Bareme.etape2.resultat.baremeAjuste.imprimerPDF')}}</li>
                                </ol>
                            </div>
                            <div id="divBaremeAjustePossible" v-else>
                                <p v-html="$t('Bareme.etape2.resultat.baremeAjuste.simulationBareme')">
                                </p>
                                <blockquote>
                                    <span v-html="$t('Bareme.etape2.resultat.baremeAjuste.lienBaremeAjuste',
                                     {url: 'https://www.ge.ch/bareme-c-impot-source/bareme-c-perception-ajuste'})">
                                    </span>
                                </blockquote>
                                <button @click="goToEtape3" class="btn btn-default" style="margin-right:5px;"
                                        :title="$t('Bareme.etape2.buttons.simulationBaremeAjuste2')">
                                    {{$t('Bareme.etape2.buttons.simulationBaremeAjuste2')}}
                                </button>
                                <p>Sinon: </p>
                                <ol>
                                    <li>{{$t('Bareme.etape2.resultat.baremeAjuste.genererPDF')}}</li>
                                    <li>{{$t('Bareme.etape2.resultat.baremeAjuste.imprimerPDF')}}</li>
                                </ol>
                            </div>
                        </div>
                        <div id="divBaremeNormal" v-else>
                            <p v-html="$t('Bareme.etape2.resultat.baremeNormal.info')"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'section-info-bareme-ajuste',
  methods: {
    getT() {
      return this.$t('Bareme.etape2.resultat.baremeAjuste.lienBaremeAjuste',
        { url: 'https://www.ge.ch/bareme-c-impot-source/bareme-c-perception-ajuste' });
    },
    goToEtape3() {
      this.$router.push({ name: 'routePrelevementEtape3' });
    },
  },
  props: {
    dossier: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>

</style>
